import request from './request';

const uri = 'vehicle/';

const vehicle = {
  get: (id = '', options) => request(uri + id, options),
  post: (options) => request(uri, { method: 'POST', ...options }),
  patch: (id, options) => request(uri + id, { method: 'PATCH', ...options }),
  put: (id, options) => request(uri + id, { method: 'PUT', ...options }),
  delete: (id, options) => request(uri + id, { method: 'DELETE', ...options })
};

export default vehicle;
